// @flow
import React from 'react';
import {InputBase, InputInlay} from 'sail/Input';
import {Select, SelectOption} from 'sail/Select';
import {CaptionMono} from 'sail/Text';
import {dimensions} from '../StyleHelpers';

type EnumInputProps = {|
  field_id: string,
  param_key: string,
  required: boolean,
  inputType: string,
  param: Object,
  params: Object,
  setParams: (Object) => void,
|};

const handleParamChange = (param_key, value, params, setParams) => {
  if (value) {
    setParams({...params, [param_key]: value});
  } else {
    const {[param_key]: removed, ...newParams} = params;
    setParams(newParams);
  }
};

export const EnumInput = ({
  field_id,
  param_key,
  required,
  inputType,
  param,
  params,
  setParams,
}: EnumInputProps) => {
  return (
    <InputBase width={dimensions.width} radius="none">
      <Select
        id={field_id}
        value={params[param_key]}
        onChange={(value) =>
          handleParamChange(param_key, value, params, setParams)
        }
        defaultValue=""
        width="maximized"
        size="large"
      >
        <SelectOption key={`${param_key}-placeholder`} value="" label="" />
        {param.input_type.enum.map((item) => (
          <SelectOption
            key={`${param_key}-${item}`}
            value={item}
            label={`${item}`}
          />
        ))}
      </Select>
      <InputInlay buffer="horizontal" size="large">
        <CaptionMono color="gray">enum</CaptionMono>
      </InputInlay>
    </InputBase>
  );
};
